import * as types from "./types";

const getGuestCartId = cartId => {
  return {
    type: types.GET_GUEST_CART_ID,
    cartId: cartId
  };
};

const getGuestCartProducts = cartProducts => {
  return {
    type: types.GET_GUEST_CART_PRODUCTS,
    cartProducts: cartProducts
  };
};

const setCartPriceAndQty = (cartPrice, cartQty) => {
  return {
    type: types.SET_CART_PRICE_AND_QTY,
    cartPrice: cartPrice,
    cartQty: cartQty,
    animateMinicart: false
  };
};

export { getGuestCartId, getGuestCartProducts, setCartPriceAndQty };



// WEBPACK FOOTER //
// ./src/modules/Cart/actions/actions.js